import { render } from "./AuteursView.vue?vue&type=template&id=6d11dc21&scoped=true"
import script from "./AuteursView.vue?vue&type=script&lang=js"
export * from "./AuteursView.vue?vue&type=script&lang=js"

import "./AuteursView.vue?vue&type=style&index=0&id=6d11dc21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d11dc21"]])

export default __exports__